import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Renderer2,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { IPredefinedScript } from '../_shared/models/predefined-script.model';
import { GridComponent } from '../grid/grid.component';

import { WindowRefService } from '../_shared/services/window-ref.service';

@Component({
    selector: 'sirius-predefined-script',
    template: `<sirius-grid><div #scriptContainer class="sir-text-style-paragraph-m-default"></div></sirius-grid>`,
    styleUrls: ['./predefined-script.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent]
})
export class PredefinedScriptComponent implements AfterViewInit, IDynamicElement {
    @ViewChild('scriptContainer') scriptContainer!: ElementRef<HTMLElement>;
    config!: IPredefinedScript;

    private _renderer = inject(Renderer2);
    private _document = inject(DOCUMENT);
    private _windowRef = inject(WindowRefService);

    ngAfterViewInit(): void {
        if (!this._windowRef.NativeWindow) {
            return;
        }

        const fragment = this._document.createRange().createContextualFragment(this.config.script);
        this._renderer.appendChild(this.scriptContainer.nativeElement, fragment);
    }
}
